// extracted by mini-css-extract-plugin
export default {"delivery":"Delivery_delivery__C8glz","pageLoad":"Delivery_pageLoad__-53Ze"};